export const RQ_DOCTOR_UPLOAD_API = {
  url: 'v2/doctor/upload',
  method: 'POST',
  auth: true,
};
